import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGetGiftPackages } from '../../../../../hooks/queries/gifts/use-get-gift-packages'
import { useGetGifts } from '../../../../../hooks/queries/gifts/use-get-gifts'

import { useListenerMessage } from '../../../../../hooks/subscription/use-listener-message'
import { useGlobalStore } from '../../../../../store/global-store'
import { Loading } from '../loading'
import { Gift } from './components/gift'
import { Observer } from './components/observer'

interface Props {
  isPackageSelected: boolean
  token?: string | null
}

export function GiftsContainer({ isPackageSelected, token }: Props) {
  const { selectedType } = useGlobalStore(
    useShallow((state) => ({
      selectedType: state.selectedType,
    })),
  )

  const {
    gifts,
    isLoading: isLoadingGifts,
    hasNextPage: hasNextPageGift,
    nextPage: nextPageGift,
  } = useGetGifts(
    { giftTypeId: selectedType?.id },
    { enabled: !isPackageSelected && Boolean(selectedType?.id), token },
  )

  const {
    gifts: giftsInPackageTypes,
    isLoading: isLoadingPackage,
    hasNextPage: hasNextPagePackage,
    nextPage: nextPagePackage,
    refetch,
  } = useGetGiftPackages({ enabled: isPackageSelected, token })

  const isLoading = isPackageSelected ? isLoadingPackage : isLoadingGifts

  const allGifts = useMemo(() => {
    return isPackageSelected ? giftsInPackageTypes : gifts
  }, [isPackageSelected, giftsInPackageTypes, gifts])

  useListenerMessage((data) => {
    if (data === 'load-gifts-packages') {
      refetch()
    }
  })

  return (
    <div
      style={{ paddingBottom: 100 }}
      className="grid grid-cols-4 overflow-y-scroll flex-1 pt-2 "
    >
      {isLoading && <Loading />}

      {(allGifts ?? []).map((gift) => (
        <Gift
          key={gift.id}
          isLocked={selectedType?.isLocked ?? false}
          gift={gift}
        />
      ))}

      <Observer
        key={String(isPackageSelected)}
        hasNextPage={isPackageSelected ? hasNextPagePackage : hasNextPageGift}
        action={isPackageSelected ? nextPagePackage : nextPageGift}
      />
    </div>
  )
}
